  <template>
  <div v-if="visible" class="activate_dialog">
    <div class="activate_dialog_content">
      <img
        src="~@/assets/images/vip/activate_head.png"
        class="activate_dialog_content_head"
      />
      <img
        src="~@/assets/images/vip/close.png"
        alt=""
        class="activate_dialog_content_close"
        @click="cancel"
      />
      <div class="vip-dialog-sjhy-body-box">
        <div class="vip-dialog-sjhy-body-box1">
          <div class="vip-dialog-sjhy-body_title">
            有效期内享以下题库会员
            <div>{{ num }}+权益</div>
          </div>
          <div class="vip-dialog-sjhy-body_method_box">
            <img
              src="~@/assets/images/vip/icon_carousel_left.png"
              class="prev"
              @click.stop="arrowClick('prev')"
            />
            <img
              src="~@/assets/images/vip/icon_carousel_right.png"
              class="next"
              @click.stop="arrowClick('next')"
            />
            <el-carousel
              ref="carousel"
              height="180px"
              indicator-position="none"
              :autoplay="false"
              :loop="false"
              arrow="never"
            >
              <el-carousel-item
                v-for="(item, index) in iconsList"
                :key="`el-carousel-item-${index}`"
              >
                <div
                  v-for="(icon, iconIdx) in item"
                  :key="`vip-list-item-${iconIdx}`"
                  class="vip-dialog-sjhy-body_method_box_item"
                  @click.stop="showMemberDialog"
                >
                  <img :src="icon.iconUrl" alt="" />
                  <p class="ms">{{ icon.menuName }}</p>
                </div>
                <div
                  v-if="item.length < 8"
                  class="vip-dialog-sjhy-body_method_box_item"
                >
                  <img
                    src="~@/assets/images/vip/icon_member_entry.png"
                    alt=""
                  />
                  <a href="javascript:void(0);" class="ckxq" @click="goMyPage">
                    查看详情
                  </a>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="vip-dialog-sjhy-body_method_btn" @click="primary">
            <img src="~@/assets/images/vip/icon_vip_logo.png" />
            <div>开通题库会员</div>
          </div>
        </div>
      </div>
    </div>
    <div class="activate_dialog_mask" @click="cancel"></div>
  </div>
</template>

<script>
import { OpenIframeDialog } from '@/components/dialog/dialog'

export default {
  name: 'ActivateVipDialog',
  props: {
    list: {
      type: Array,
      default: () => []
    },
    url: {
      type: String,
      default: ''
    },
    link: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      visible: false,
      iconsList: [],
      num: '',
      pcUrl: ''
    }
  },
  watch: {
    list: {
      handler() {
        this.initData()
      },
      immediate: true
    }
  },
  methods: {
    initData() {
      const list = []
      let arr = []
      this.num = this.list.length
      this.list?.forEach((a) => {
        arr.push(a)
        if (arr.length === 8) {
          list.push(arr)
          arr = []
        }
      })
      list.push(arr)
      this.iconsList = list
    },
    arrowClick(type) {
      if (type === 'prev') {
        this.$refs.carousel.prev()
      } else {
        this.$refs.carousel.next()
      }
    },
    // 确认
    primary() {
      this.$emit('done')
      this.goMyPage()
    },
    cancel() {
      this.$emit('cancel')
    },
    goMyPage() {
      this.$emit('done')
      window.CDEL.loginStatus((cb) => {
        if (cb.loginFlag) {
          const tempwindow = window.open('_blank')
          tempwindow.location = this.link
        } else {
          window.CDEL.ucLogin()
          return false
        }
      })
    },
    showMemberDialog() {
      this.url &&
        OpenIframeDialog({
          url: this.url
        })
    }
  }
}
</script>

<style scoped lang="scss">
.activate_dialog {
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;

  &_content {
    padding-bottom: 30px;
    width: 300px;
    min-height: 200px;
    border-radius: 24px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 10;

    &_head {
      position: absolute;
      top: -78px;
      z-index: -1;
    }

    &_close {
      width: 16px;
      height: 16px;
      cursor: pointer;
      position: absolute;
      right: 10px;
      top: -94px;
      z-index: 99;
    }

    .vip-dialog-sjhy-body-box {
      width: 300px;
      height: 300px;
      background: linear-gradient(
        180deg,
        rgba(254, 211, 147, 1),
        rgba(255, 221, 171, 1)
      );
      border-radius: 26px;
      position: relative;

      &::after {
        content: '';
        background: linear-gradient(
          136deg,
          #ffe6b3 0%,
          #fff7e6 44%,
          #ffe3a9 100%
        );
        border-radius: 24px;
        /* 圆角值 = 外层圆角 - 边框宽度 */
        position: absolute;
        top: 2px;
        /* 与 padding 一致 */
        left: 2px;
        right: 2px;
        bottom: 2px;
      }
    }

    .vip-dialog-sjhy-body-box1 {
      position: relative;
      z-index: 3;

      .vip-dialog-sjhy-body_title {
        text-align: center;
        font-weight: bold;
        font-size: 16px;
        color: #333333;
        line-height: 21px;
        padding-top: 29px;

        div {
          color: #ff2929;
          display: inline-block;
          padding-left: 4px;
        }
      }

      .vip-dialog-sjhy-body_method_box {
        position: relative;
        padding: 2px 7px 0;

        .prev {
          position: absolute;
          z-index: 4;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
        }

        .next {
          position: absolute;
          right: 0;
          z-index: 4;
          top: 50%;
          transform: translateY(-50%);
        }

        .vip-dialog-sjhy-body_method_box_item {
          display: inline-block;
          margin: 15px 5px 0;
          width: 60px;
          text-align: center;

          img {
            margin-bottom: 9px;
            width: 40px;
            height: 40px;
          }

          .ckxq {
            margin-top: -4px;
            display: inline-block;
            width: 60px;
            height: 24px;
            border-radius: 12px;
            border: 1px solid #b95800;
            font-size: 12px;
            color: #b95800;
            line-height: 24px;
            text-align: center;
            cursor: pointer;
          }

          .ms {
            font-size: 12px;
            color: #333333;
            line-height: 16px;
            text-align: center;
            white-space: nowrap;
          }
        }
      }

      .vip-dialog-sjhy-body_method_btn {
        cursor: pointer;
        margin: 0 auto;
        width: 184px;
        height: 44px;
        background: url(~@/assets/images/vip/bg_btn_vip.png) no-repeat center;
        background-size: 100% 100%;
        position: relative;

        img {
          width: 18px;
          height: 15px;
          position: absolute;
          top: 15px;
          left: 31px;
        }

        div {
          padding-left: 55px;
          font-weight: bold;
          font-size: 16px;
          color: #ffffff;
          line-height: 44px;
        }
      }
    }
  }

  &_mask {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    z-index: 1;
  }
}
</style>
